<template>
    <CCard>
        <CCardHeader style="background:#1a3665;color:white" class="d-flex align-items-center font-weight-bold"> Master Karir
            <template v-if="role_status && role_status.status_create">
                <CButton color="success" class="btn-md ml-auto" @click="openTambahModal ">Tambah</CButton>
            </template>
            <template v-else>
                <CButton color="secondary" class="btn-md ml-auto" disabled>Tambah</CButton>
            </template>
        </CCardHeader>
        <CCardBody>
        <CRow>
            <CCol xl="12">
                <CSelect
                    label="Data Perhalaman"
                    class="float-left"
                    @change="changePageSize"
                    :options="[10, 25, 100, 'Semua Data']"
                />
                <CInput
                    label="Pencarian"
                    class="float-right"
                    placeholder="Cari Data .."
                    v-model="search"
                    @keyup="cariData"
                />
                <br />
            </CCol>       
            <CCol lg="12" class="table-responsive">
                <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
                    <template #no="{index}">
                        <td class="py-2">{{ index + 1 }}</td>
                    </template>
                    <template #flyer="{item}">
                        <td class="py-2">
                            <img                                
                                :src="baseUrl + '/files?filename=' + item.flyer + '&path=datamaster@karir'"
                                class="img-fluid"
                                style="max-height: 50px;"
                            />
                        </td>
                    </template>
                    <template #posisi="{item}">
                        <td class="py-2">{{ item.posisi ? item.posisi : '-' }}</td>
                    </template>
                    <template #description="{item}">
                        <td class="py-2">{{ item.description ? (item.description.length > 100 ? item.description.substring(0, 50) + '...' : item.description) : '' }}</td>
                    </template>
                    <template #file="{item}">
                        <td class="py-2">
                            <button class="btn btn-info" :disabled="!item.file" @click="lihatFile(item.file)">
                                Lihat File
                            </button>
                        </td>
                    </template>       
                    <template #status="{item}">
                        <td class="py-2 text-center">
                            <font-awesome-icon icon="check" class="text-success" v-if="item.status == 1" />
                            <font-awesome-icon icon="times" class="text-danger" v-else />
                        </td>
                    </template>                       
                    <template #aksi="{item, index}">
                        <td class="py-2 text-center d-flex align-items-center">
                            <template v-if="role_status && role_status.status_read">
                                <CButton 
                                    v-c-tooltip="'Detail'" 
                                    color="success" 
                                    square size="sm" 
                                    style="margin-right:8px"
                                    @click="showDetail(item)"
                                >
                                    <font-awesome-icon icon="eye" />
                                </CButton>&nbsp;&nbsp;  
                            </template>
                            <template v-else>
                                <CButton 
                                    v-c-tooltip="'Detail'" 
                                    color="secondary" 
                                    square size="sm" 
                                    style="margin-right:8px"
                                    disabled
                                >
                                    <font-awesome-icon icon="eye" />
                                </CButton>&nbsp;&nbsp;  
                            </template>   
                            <template v-if="role_status && role_status.status_update">
                                <CButton v-c-tooltip="'Ubah'" color="info" square size="sm" @click="updateData(item, index)">
                                <font-awesome-icon icon="edit" />
                                </CButton>&nbsp;&nbsp;
                            </template>
                            <template v-else>
                                <CButton v-c-tooltip="'Ubah'" color="secondary" square size="sm" disabled>
                                <font-awesome-icon icon="edit" />
                                </CButton>&nbsp;&nbsp;
                            </template>
                            <template v-if="role_status && role_status.status_delete">
                                <CButton v-c-tooltip="'Hapus'" color="danger" square size="sm" @click="deleteData(item, index)">
                                <font-awesome-icon icon="trash" />
                                </CButton>
                            </template>
                            <template v-else>
                                <CButton v-c-tooltip="'Hapus'" color="secondary" square size="sm" disabled>
                                <font-awesome-icon icon="trash" />
                                </CButton>
                            </template>
                        </td>
                    </template>
                </CDataTable>
            <CPagination
                style="float:right"
                :active-page.sync="currentPage"
                :pages="pagination.totalPages"
                responsive
                @click="pageChange"
            />
            </CCol>
        </CRow>
        </CCardBody>      

        <!-- Modal Tambah -->
        <CModal
            :title="title"
            :show.sync="myModal"
            :no-close-on-backdrop="true"        
            :centered="true"
        >
            <template #header>
                <h6 class="modal-title h4 font-weight-bold">{{ title }}</h6>          
            </template>
            <CForm v-on:submit.prevent="postData">
                <div class="form-group">
                    <label for="nama_posisi">Nama Posisi</label>
                    <input 
                        type="text" 
                        class="form-control" 
                        id="nama_posisi" 
                        placeholder="Masukkan Nama Posisi" 
                        v-model="formData.position"
                        :class="{
                            'is-invalid': $v.formData.position.$error,                   
                        }"
                    >   
                </div>                
                <div class="form-group">
                    <label for="description">Deskripsi</label>
                    <textarea 
                        type="text" 
                        class="form-control" 
                        id="description" 
                        placeholder="Masukkan Deskripsi" 
                        v-model="formData.description"
                        :class="{
                            'is-invalid': $v.formData.description.$error,                   
                        }"
                    ></textarea>
                </div>                
                <div class="form-group">                                   
                    <label class="font-weight-bold">
                        Unggah Flyer
                        <small v-if="actionPost == 'update' && typeof formData.flyer === 'string'">
                            <span @click="lihatFile(formData.flyer)" style="cursor: pointer;">(Lihat Flyer)</span>
                        </small>
                    </label>
                    <div class="custom-file text-truncate">
                        <input 
                            type="file" 
                            class="custom-file-input" 
                            id="customFlyerLangHTML" 
                            ref="flyerKarir"
                            @change="handleFlyerUpload"                
                            accept="image/*" 
                        />
                        <label
                            class="custom-file-label"
                            for="customFlyerLangHTML"
                            data-browse="Unggah"
                        >       
                            {{ typeof formData.flyer === "string" ? formData.flyer : flyername }}                                     
                        </label> 
                    </div>
                </div>
                <div class="form-group">
                    <label  class="font-weight-bold">
                        Unggah File
                        <small v-if="actionPost == 'update' && typeof formData.file === 'string'">
                            <span @click="lihatFile(formData.file)" style="cursor: pointer;">(Lihat File)</span>
                        </small>
                    </label>
                    <div class="custom-file text-truncate">                        
                        <input 
                            type="file" 
                            class="custom-file-input" 
                            id="customFileLangHTML" 
                            ref="fileKarir"
                            @change="handleFileUpload"
                        />
                        <label
                            class="custom-file-label"
                            for="customFileLangHTML"
                            data-browse="Unggah"
                        >       
                            {{ typeof formData.file === "string" ? formData.file : filename }}                                  
                        </label>    
                    </div>                    
                </div>      
                <div class="form-group mb-4">
                    <label for class="font-weight-bold">Status</label>
                    <br />
                    <div class="d-flex align-items-center">
                        <div class="custom-control custom-radio custom-control-inline">
                            <input
                                type="radio"
                                class="custom-control-input"                    
                                name="customRadio"
                                id="aktif"
                                value="1"
                                v-model="formData.status"
                                aria-required="true"
                                checked
                            />
                            <label class="custom-control-label" for="aktif">Aktif</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input
                                type="radio"
                                class="custom-control-input"
                                name="customRadio"
                                id="tidak_aktif"
                                value="0"
                                v-model="formData.status"
                            />
                            <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
                        </div>                                        
                    </div>            
                    <span v-if="$v.formData.status.$error" class="text-danger">
                        *Mohon pilih status
                    </span>        
                </div>     
            </CForm>            
            <template #footer>
                <CButton @click="myModal = false" color="danger">Tutup</CButton>
                <CButton @click="postData" type="submit" color="success">Simpan</CButton>
            </template>
        </CModal>
        <!-- End Modal Tambah --> 

        <!-- Modal Detail -->
        <CModal
            title="Detail Karir"        
            :show.sync="detailModal"                 
            :no-close-on-backdrop="true"
            :centered="true"            
        >
            <template #header>
                <h6 class="modal-title h4 font-weight-bold float-right">Detail Karir</h6>          
                <button class="btn" @click="detailModal = false">
                    <font-awesome-icon icon="times" />
                </button>
            </template>
            <div class="table-responsive">
                <table class="table table-bordered">
                    <tbody>
                    <tr>                        
                        <th colspan="2" class="text-center">
                            <img
                                class="img-fluid"
                                style="max-width: 200px;"
                                :src="baseUrl + '/files?filename=' + item.flyer + '&path=datamaster@karir'"
                            />
                        </th>
                    </tr>
                    <tr>
                        <th class="w-25">Posisi</th>
                        <th>{{ item.position ? item.position : '-' }}</th>
                    </tr>
                    <tr>
                        <th>Deskripsi</th>
                        <th>{{ item.description ? item.description :'-' }}</th>
                    </tr>
                    <tr>
                        <th>File</th>
                        <th>
                            <button class="btn btn-info" :disabled="!item.file" @click="lihatFile(item.file)">
                                Lihat File
                            </button>
                        </th>
                    </tr>                               
                    <tr>
                        <th>Status</th>
                        <th>{{ item.status === '1' ? 'Aktif' : 'Tidak Aktif' }}</th>
                    </tr>                               
                    </tbody>
                </table>
            </div>
            <template #footer>
                <CButton @click="detailModal = false" color="danger">Tutup</CButton>          
            </template>
        </CModal>
        <!-- Modal Detail --> 
    </CCard>
</template>

<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import KarirService from '../../services/datamaster/karir.service';
import { AlertUtils } from "../../mixins/AlertUtils"
import BaseUrl from "../../services/base-url";

const fields = [
  { key: "no" },
  { key: "flyer", label: "Flyer" },
  { key: "position", label: "Posisi" },
  { key: "description", label: "Deskripsi" },
  { key: "file", label: 'File' },  
  { key: 'status', label: 'Status', _style: " text-align: center" },
  {
    key: "aksi",
    _style: "width:12%; text-align: center"   
  }
];

export default {
    name: 'Karir',

    mixins: [
        AlertUtils
    ],

    data() {
        return {
            item: {},
            items: [],
            fields,            
            detailModal: false,
            myModal: false,
            formData: {
                posisi: '',
                decription: '',
                file: '',
                flyer: '',
                status: ''
            },
            actionPost: 'insert',
            title: 'Tambah',
            flyername: 'Pilih Flyer',
            filename: 'Pilih File',
            search: "",
            pagination: {
                totalPages: 0
            },
            pageSize: "10",
            currentPage: 0,
            baseUrl: "",
            role_status: null
        }
    },

    validations: {
        formData: {
            position: { required },
            description: { required },
            status: { required },
            flyer: {
                required: requiredIf(function () {
                    return this.actionPost === 'insert';
                })
            },
            file: {
                required: requiredIf(function () {
                    return this.actionPost === 'insert';
                })
            }
        }
    },

    mounted() {
        this.baseUrl = BaseUrl();
        this.getData('0', 1, 'default');
        this.roleData();
    },

    watch: {
        currentPage: function(val) {            
            var page = val - 1;
            this.indexed = page * 10;            
            this.getData(val - 1, this.pageSize, this.search);            
        },

        myModal: function() {
            this.$v.$reset();       
        }
    },  

    methods: {
        roleData()
        {
            var user = JSON.parse(localStorage.getItem('user'));
            var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
            this.role_status = data;
        },
        getData(currentPage, pageSize, filter) {            
            let loader = this.$loading.show({
                container: false ? null : this.$refs.formContainer,
                canCancel: true,
                onCancel: this.onCancel
            });

            KarirService.getKarir(currentPage, pageSize, filter) 
                .then(response => {                                           
                    this.items = response.data.data.content;
                    this.pagination.totalPages = response.data.data.totalPages;
                    this.currentPage = response.data.data.pageable.pageNumber + 1;
                    loader.hide();
                })
                .catch(error => {
                    loader.hide();
                    // comment console console.log(error)
                })            
        },

        changePageSize(e) {
            // comment console console.log(e.target.value);
            var pageSize = "";

            if (e.target.value == "Semua Data") {
                pageSize = "500";
                this.pageSize = pageSize;
            } else {
                pageSize = e.target.value;
                this.pageSize = pageSize;
            }
            this.getData("0", pageSize, this.search);
        },

        cariData() {            
            clearTimeout(this.timeout);
            var vm = this;
            this.timeout = setTimeout(function() {
                vm.getData("0", vm.pageSize, vm.search);
            }, 1000);
        },

        pageChange() {
            this.getData(currentPage, this.pageSize, this.search);
        },

        showDetail(item) {
            this.item = item;
            this.detailModal = true;
        },

        handleFlyerUpload(e) {
            let file = e.target.files[0];            
            this.formData.flyer = file;          
            this.flyername = file.name; 
            this.$v.formData.flyer.$touch();
        },

        handleFileUpload(e) {
            let file = e.target.files[0];            
            this.formData.file = file; 
            this.filename = file.name;
            this.$v.formData.file.$touch();
        },        

        openTambahModal() {
            this.myModal = true;            
            this.formData = {};
            this.$refs.flyerKarir.value = null;
            this.$refs.fileKarir.value = null;
            this.flyername = 'Pilih Flyer';
            this.filename = 'Pilih File';
            this.actionPost = 'insert';
            this.title = 'Tambah';
        },

        updateData(item, index) {
            this.myModal = true;
            this.formData = item;            
            this.flyername = item.flyer ? item.flyer : 'Pilih Flyer';
            this.filename = item.file ? item.file : 'Pilih File';
            this.actionPost = "update";
            this.title = "Edit";      
        },

        postData() {
            this.$v.$touch();
            if (this.actionPost == "insert") {
                if (this.$v.$invalid) {
                    return;
                } else {
                    this.insertData(this.formData);
                }
            } else if (this.actionPost == "update") {
                if (this.$v.$invalid) {
                    return;
                } else {
                    this.putData();
                }
            }
        },

        insertData(formData) {
            let loader = this.$loading.show({
                container: false ? null : this.$refs.formContainer,
                canCancel: true,
                onCancel: this.onCancel
            });
            var vm = this;
            if (typeof formData.flyer === "string") {
                delete formData.flyer
            }

            if (formData.flyer === null) {
                delete formData.flyer
            }

            if (typeof formData.file === "string") {
                delete formData.file
            }

            if (formData.file === null) {
                delete formData.file
            }

            KarirService.postKarir(formData)
                .then(response => {
                    vm.formData = {};                    
                    loader.hide();
                    vm.myModal = false;
                    vm.alertSuccess();
                    vm.getData('0', this.pageSize, this.search);
                })
                .catch(error => {
                    loader.hide();
                    vm.myModal = false;
                    // comment console console.log(error.response.data.message);
                    vm.alertError(error.response.data.message);
                });           
        },

        putData() {            
            let loader = this.$loading.show({
                container: false ? null : this.$refs.formContainer,
                canCancel: true,
                onCancel: this.onCancel
            });
            
            if (typeof this.formData.flyer === "string") {
                delete this.formData.flyer;
            }

            if (this.formData.flyer === null) {
                delete this.formData.flyer;
            }

            if (typeof this.formData.file === "string") {
                delete this.formData.file;
            }

            if (this.formData.file === null) {
                delete this.formData.file;
            }

            var vm = this;
            KarirService.putKarir(this.formData)    
                .then(response => {                    
                    vm.formData = {}
                    vm.myModal = false;
                    vm.alertEditSuccess();
                    loader.hide();
                    vm.getData('0', 10, 'default');
                })
                .catch(error => {                      
                    vm.myModal = false;
                    vm.alertError();
                    loader.hide();
                    vm.getData('0', 10, 'default');
                })          
        },

        lihatFile(file) {            
            if (file != "" && file != null) {
                let routeData = this.baseUrl + "/files?filename=" + file + "&path=datamaster@karir";
                window.open(routeData, "_blank");
                return false;
            } else {
                this.$swal.fire({
                title: "Informasi",
                text: "File Tidak Ditemukan.",
                icon: "info",
                confirmButtonText: "Tutup",
                showConfirmButton: true
                });
            }
        },

        deleteData(item, index) {               
            this.formData = item;      
            this.$swal
                .fire({
                    title: "Peringatan!",
                    text: "Apakah anda yakin ingin menghapus data ini ?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Ya",
                    cancelButtonText: "Tidak",
                    confirmButtonColor: "#d33",
                    cancelButtonColor: "#3085d6",
                    reverseButtons: true
                })
                .then(result => {
                    if (result.value) {
                        KarirService.deleteKarir(this.formData)
                            .then(response => {
                                this.alertDeleteSuccess();
                                this.getData("0", this.pageSize, "default");
                            })
                            .catch(error => {
                                this.alertError();
                                this.getData("0");
                                // comment console console.log(error);
                            });               
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                        this.$swal.fire(
                            "Cancelled",
                            "Your imaginary file is safe :)",
                            "error"
                        );
                    }
                });
        },
    }
}
</script>

<style scoped>
    button:disabled {
        cursor: no-drop;
    }
    .no-border {
        border: 0;
        box-shadow: none; /* You may want to include this as bootstrap applies these styles too */
    }
</style>